
import Autobrightness from "../../../assets/outline/Autobrightness.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AutobrightnessIcon({ className, dataTestid = "AutobrightnessIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Autobrightness data-testid={dataTestid} className={classes} {...rest} />
  );
}
